import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {FormGroup} from "@angular/forms";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-formattedexplanation',
  templateUrl: './spec-formattedexplanation.component.html',
  imports: [
    SharedUiButtonModule,
    CommonModule,
    SharedUiDialogModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  styleUrls: ['./spec-formattedexplanation.component.scss']
})
export class SpecFormattedexplanationComponent implements OnChanges{

  @Input({ required: true }) public title = {} as string;
  @Input({ required: true }) public input!:  FormGroup;
  @Input() public dialogVisible = false;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  @Output() public inputChange = new EventEmitter<FormGroup>();

  private initialFormValue: any;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    }

  ngOnChanges(changes: SimpleChanges) {
    if (this.input&& changes) {
      this.initialFormValue = this.input.getRawValue();
    }
  }

  cancel() {
    this.input.reset(this.initialFormValue);
    this.dialogVisibleChange.emit(false)
  }

  submit() {
    this.dialogVisibleChange.emit(false)
    this.inputChange.emit(this.input)
  }
}
